
import i18nService from "../api/i18nService";

export default function i18nFilter(key) {
  if (!key) return ''
  return i18nService.localize(key)
}



// WEBPACK FOOTER //
// ./src/filters/i18nFilter.js